module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "infoProductModal",
    staticClass: "modal fade",
    attrs: {
      "id": "infoProductModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-red",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('menu-options', {
    ref: 'menu-options-' + _vm.currentProduct[_vm.schema.product.product_id],
    attrs: {
      "currentProduct": _vm.currentProduct,
      "checkPrice": _vm.checkPrice,
      "checkAddProduct": _vm.checkAddProduct,
      "checkAddDifProduct": _vm.checkAddDifProduct,
      "productAmount": _vm.number,
      "pAIndex": 1,
      "menuJson": _vm.menuJson
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "col-xs-12 p-x-0 order-item m-t-15 p-5"
  }, [_c('p', [_vm._v("總金額：" + _vm._s(_vm.totalPrice()) + " 元")]), _vm._v(" "), _c('div', {
    staticClass: "q-numeric textfield row inline items-center input-number m-x-0 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon numeric-left c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number--
      }
    }
  }, [_vm._v("\n                    -\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "no-style auto q-input-field inline-block text-center",
    attrs: {
      "type": "tel",
      "pattern": "[0-9]*",
      "tabindex": "0",
      "step": "1",
      "min": "1",
      "max": "99",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon numeric-right  c-pointer bg-pink",
    on: {
      "click": function($event) {
        _vm.number++
      }
    }
  }, [_vm._v("\n                    +\n                  ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickAdd
    }
  }, [_vm._v("測試")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1efd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/MenuModalNew.vue
// module id = 2468
// module chunks = 1